import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultInvoicePrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/Recibes/Print/templates/*/index.tsx"
);

type RecibePrintProps = {
};

export default function RecibePrint(props: RecibePrintProps) {
  return (
    <TenantTemplateRouterCore<RecibePrintProps>
      templates={templates}
      DefaultComponent={DefaultInvoicePrint}
      passProps={props}
    />
  );
}